<template>
  <v-layout align-center justify-center column fill-height id="layout">
    <v-layout column>
      <v-flex xs12>
        <v-img
          :src="require('../assets/logo.svg')"
          class="my-3"
          contain
          height="23"
          width="366"
        ></v-img>
        <div class="text-xs-center" v-if="isLoading">
          <v-progress-circular
            :size="70"
            :width="7"
            color="white"
            indeterminate
          ></v-progress-circular>
        </div>
        <LoginForm v-else />
      </v-flex>
    </v-layout>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex';
import LoginForm from '../components/LoginForm.vue';

export default {
  name: 'Login',
  components: {
    LoginForm,
  },
  computed: {
    ...mapState('user', ['isLoading']),
  },
};
</script>

<style scoped>
  #layout {
    background: #008ee9;
    background: -moz-radial-gradient(
      center, ellipse cover, #008ee9 1%, #008ee9 66%, #1095e8 70%, #8ccef6 100%
    );
    background: -webkit-radial-gradient(
      center, ellipse cover, #008ee9 1%,#008ee9 66%,#1095e8 70%,#8ccef6 100%
    );
    background: radial-gradient(ellipse at center, #008ee9 1%,#008ee9 66%,#1095e8 70%,#8ccef6 100%);
    filter: progid:DXImageTransform.Microsoft.gradient(
      startColorstr='#008ee9', endColorstr='#8ccef6',GradientType=1
    );
  }
</style>
